import { RootState } from 'internal/rootReducer';

export const selectLocale = (state: RootState): string | null => state.appState.locale;

export const selectLocales = (state: RootState): string[] => state.appState.locales;
